<template>
  <div class="tab global_pointer" :class="{ selected: currentTab === info.type }">
    <img :src="info.icon" alt="" />
    <span>{{ $t('message.home.'+info.type) }}</span>
  </div>
</template>
<script>
export default {
  name: 'Tab',
  props: ['info', 'currentTab'],
  methods: {
    // tabClick(type) {
    //   console.log(type);
    //   this.$emit('tab-change', { type });
    // },
  },
};
</script>
<style lang="less" scoped>
.tab {
  margin-right: 4px;
  padding: 8px;
  background: #1d1d1d;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  border: 1px solid #1d1d1d;
  &.selected {
    border: 1px solid #39d2d6;
  }
  & img {
    width: 28px;
    height: 28px;
    margin-right: 8px;
  }
  & span {
    display: inline-block;
    height: 18px;
    font-size: 13px;
    font-weight: bold;
    color: #ffffff;
    line-height: 18px;
    word-break:keep-all;
    white-space: nowrap;
    font-family: "Approach-SemiBold";
  }
}
</style>
